import React, { useState } from 'react';
import {
  Button, Card, Column, DataRow, Row, Typography,
} from '@tempmee/react';
import { EMPTY_VALUE } from '../../../../domain/Users';
import { locationUserProfilePropType } from '../constants';
import { AccountInfoForm } from './AccountInfoForm';
import { RateLimitsTable } from './RateLimitsTable';

/**
 * Account Info: the identity's own fields from auth-service, editable in
 * place, and its rate limit in each organization it belongs to.
 *
 * Account status, Set Your Password, consent, app version and platform are left
 * out by the ticket rather than shown as placeholders, and the timezone and the
 * rate limits are read-only here.
 */
export const AccountInfoTab = ({ user }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Column gap={4}>
      <Card outline>
        <Column px={5} py={4} gap={2}>
          <Row justify="between" align="center">
            <Typography variant="h6" as="h1">
              Account Info
            </Typography>
            {!isEditing ? (
              <Button variant="outlined" size="small" onClick={() => setIsEditing(true)}>
                Edit
              </Button>
            ) : null}
          </Row>

          {isEditing ? (
            <AccountInfoForm user={user} onClose={() => setIsEditing(false)} />
          ) : (
            <>
              <DataRow label="First Name" value={user.firstName || EMPTY_VALUE} />
              <DataRow label="Last Name" value={user.lastName || EMPTY_VALUE} />
              <DataRow label="Email" value={user.email || EMPTY_VALUE} />
              <DataRow label="Phone" value={user.phoneLabel} />
            </>
          )}
          <DataRow label="Created Date" value={user.createdAtLabel} />
          <DataRow label="Last Login" value={user.lastLoginLabel} />
          <DataRow label="Timezone" value={user.timeZoneLabel} divider={false} />
        </Column>
      </Card>

      <RateLimitsTable identityId={user.id} />
    </Column>
  );
};

AccountInfoTab.propTypes = {
  user: locationUserProfilePropType.isRequired,
};

export default AccountInfoTab;
